
import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'
import { Grid } from '@mui/material'
import React from 'react'
import alan from "../../../../../assets/images/alan.png"
import linkedin from "../../../../../assets/images/linkedin.png"
import { Heading, P, SectionSmallHeading } from '../../../../Styles/style'
const Wrapper = styled.div`
    background-color: ${(props) => props.theme.bgTertiary};
    padding: 20px;
    text-align: left;
    width: 100%;
    max-width: 400px;
`
const ContImg = styled.img`
    width: 100%;
    max-width: 400px;
    height: 100%;
    min-height: 380px;
`
const ContCards = (props) => {
    const theme = useTheme()
    return (
        <div>
            <Wrapper>
                <ContImg src={props.img} />
                <P p="10px 0" m="0" color={theme.textSecondary}>{props.desig}</P>
                <Heading p="10px 0" fs="25px" colors={theme.textSecondary}>{props.name}</Heading>
                <a href={props.linkedinlink}> <img src={linkedin} /></a>
            </Wrapper>
        </div>
    )
}

export default ContCards